import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarCategoriasDocumento,
  type ListarCategoriasParams,
} from "../services/categorias-documento-service";

/**
 * Listado PAGINADO (server-side) del catálogo de categorías de documento ·
 * búsqueda + página en el queryKey. Las mutations invalidan por prefijo
 * `qk.adminCategoriasDocumento`, que cubre todas las variantes de params.
 */
export const categoriasDocumentoAdminQueryOptions = (
  params: ListarCategoriasParams = {},
) =>
  queryOptions({
    queryKey: [...qk.adminCategoriasDocumento, params] as const,
    queryFn: () => listarCategoriasDocumento(params),
    placeholderData: keepPreviousData,
  });

export function useCategoriasDocumentoAdmin(params: ListarCategoriasParams = {}) {
  return useQuery(categoriasDocumentoAdminQueryOptions(params));
}
